<template>
  <div class="sc-card mb-3">
    <div class="sc-card-body">
      <h4 class="sc-card-title">Conta bancária</h4>

      <!-- lista de contas bancárias -->
      <ul class="sc-card-list" v-if="bankAccount.id">
        <li
          class="sc-card-list-item d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="sc-badge sc-badge-lg sc-badge-card mr-2"
              style="border-radius: 12px;"
            >
              <Icon
                name="dollar-sign-icon"
                :height="24"
                :width="24"
                style="stroke: #495057;"
              />
            </span>
            <div>
              <h6
                class="text-size-4 text-weight-medium"
                :style="useStyles.colorDark"
              >
                {{ bankAccount.bank_name }}
              </h6>
              <span
                class="text-size-3 text-weight-medium"
                :style="useStyles.colorGray"
              >
                Conta corrente {{ bankAccount.account_number }}
              </span>
            </div>
          </div>

          <Icon
            role="button"
            class="pointer"
            name="trash-icon"
            :height="22"
            :width="22"
            color="#f8002d"
            @click.native="deleteBankAccount()"
          />
        </li>
      </ul>
    </div>

    <div class="sc-card-divider m-0" />

    <div class="sc-card-footer" v-if="!bankAccount.id">
      <Button
        class="d-flex align-items-center"
        variant="link"
        @click.native="handleBankAccount"
      >
        <Icon class="mr-2" name="plus-icon" :width="20" :height="20" />
        Adicionar conta para transferência
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "./Button";
import Icon from "./CustomIcons";
import Swal from "sweetalert2";

export default {
  name: "BankAccountCard",
  components: {
    Button,
    Icon
  },
  methods: {
    handleBankAccount() {
      return this.$bvModal.show("bankAccount");
    },
    deleteBankAccount() {
      Swal.fire({
        title: "Confirmar exclusão de conta?",
        text: "Você poderá criar uma nova conta logo após!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#49838a",
        cancelButtonColor: "#cb6262",
        confirmButtonText: "Sim, deletar!",
        cancelButtonText: "Cancelar"
      }).then(async result => {
        if (result.isConfirmed) {
          Swal.showLoading();
          await this.$store
            .dispatch("doctor/deleteBankAccount")
            .then(() => {
              Swal.fire(
                "Sucesso!",
                "Sua conta foi deletada com sucesso.",
                "success"
              );
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: "Erro ao processar a transação",
                text: "Tente novamente mais tarde!"
              });
            });
        }
      });
    }
  },
  computed: {
    bankAccount() {
      return this.$store.state.doctor.bank_account;
    },
    useStyles() {
      return {
        colorDark: {
          color: "#343A40"
        },
        colorGray: {
          color: "#adb5bd"
        },
        colorDarkGray: {
          color: "#495057"
        }
      };
    }
  }
};
</script>
